import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { EventProfileCreateRequest } from '~client/model/admin/event-profile-create-request';
import { EventProfileUpdateRequest } from '~client/model/admin/event-profile-update-request';
import { EventResponse } from '~client/model/admin/event-response';
import { EventTranslationRequest } from '~client/model/admin/event-translation-request';
import { EventListResponse } from '~client/model/event-list-response';
import { ResponseEntity } from '~client/model/response-entity';

/* Admin APIs to manage events */
export class EventAdminController extends BaseController {
  /**
   * Returns all details about an event
   * @param eventId
   */
  public getEvent$(eventId: number): Observable<EventResponse> {
    return this.get$('/event/admin/profile', { eventId });
  }

  /**
   * Returns a list of all events without filters
   * @param showUpcomingEvents
   */
  public getEvents$(showUpcomingEvents?: boolean): Observable<EventListResponse> {
    return this.get$('/event/admin/profileList', { showUpcomingEvents });
  }

  /**
   * Creates an event
   * @param request
   */
  public createEventProfile$(request: EventProfileCreateRequest): Observable<EventResponse> {
    return this.post$('/event/profile', request);
  }

  /**
   * Updates an event
   * @param request
   */
  public updateEventProfile$(request: EventProfileUpdateRequest): Observable<EventResponse> {
    return this.put$('/event/profile', request);
  }

  /**
   * Adds name, description, restrictions, and timeline translations to an existing event
   * @param request
   */
  public addEventTranslations$(request: EventTranslationRequest): Observable<ResponseEntity> {
    return this.post$('/event/profile/addTranslations', request);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/event-admin-controller.ts